import { RedirectPublication } from 'common/client-data-types/publication'
import { getArticleAndRedirectCommonProps } from 'common/__api-mapping/v4/publication/map/common'
import { ArticleV4DTO } from 'publication-types'

export function mapRedirect(publication: ArticleV4DTO): RedirectPublication {
    const commonProps = getArticleAndRedirectCommonProps(publication)
    const redirectUrl = publication.redirectUrl || ''

    return {
        ...commonProps,

        kind: 'redirect',

        redirectUrl,
    }
}
